import { register } from '!/repository'
import { createEvent, createStore } from 'effector'

// TODO: remove this from entities, it should be related to the player, not an independent thing

interface IInfoPopupProps {
  condition: boolean
  episodeId: number | null
  eventDescription: string | null
  title: string | null
  name: string | null
  description: string | null
  directors: string | null
  stars: string | null
  length: string | null
  labels: string[] | null
}

export const init = createEvent()
export const openInfoPopup = createEvent<IInfoPopupProps>()

const emptyState = {
  condition: false,
  episodeId: null,
  description: null,
  directors: null,
  stars: null,
  resolution: null,
  length: null,
  title: null,
  name: null,
  labels: null,
  eventDescription: null,
}

export const closeInfoPopup = createEvent()

const $infoPopup = createStore<IInfoPopupProps>(emptyState)
  .on(openInfoPopup, (_, payload) => ({ ...payload, condition: true }))
  .on(closeInfoPopup, () => emptyState)

register($infoPopup, '$infoPopup')
register(openInfoPopup, 'openInfoPopup')
register(closeInfoPopup, 'closeInfoPopup')
